<template>
	<div class="home">
		<div
			class="container"
			ref="tv"
		>
			<div class="overlay" />
			<div
				v-if="hasHeader"
				class="container__header"
			/>
			<div class="container__body">
				<div
					v-if="hasHeader"
					class="container__body__status"
				>
					<slot name="header" />
				</div>
				<slot />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'DeviceComponent',
	mounted() {
		setTimeout(() => { // animation
			const tv = this.$refs.tv as HTMLElement
			return tv.classList.add('container--on')
		}, 0)
	},
	computed: {
		hasHeader() {
			return !!this.$slots.header
		}
	}
})
</script>

<style lang="scss">
	.home {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1.3em;
		background: url('~@images/wall.jpg') center center;
		background-size: cover;

		.container {
			position: relative;
			display: flex;

			width: 100%;
			border-radius: 5px;
			max-width: 640px;
			min-height: 360px;

			border: 8px solid $color-black;
			box-shadow: 2px 4px 4px rgba($color-black, 0.5);
			font-size: 22px;
			color: $color-grey;

			&:before {
				content: "";
				position: absolute;
				top: calc(100% + 8px);
				left: 50%;
				width: 5px;
				height: 50vh;
				transform: translate(-50%);
				z-index: -1;
				background-color: $color-white;
				box-shadow: 0 0 3px rgba($color-grey, 0.3);
				opacity: 0.5;
			}

			.overlay {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				background: rgb(0,0,0);
				z-index: 2;
				transition: all 1s cubic-bezier(0.5, 0, 0.75, 0);
				pointer-events: none;
			}

			&--on .overlay {
				background-color: transparent;
				transition: all 1s cubic-bezier(0.5, 0, 0.75, 0);
				pointer-events: none;
			}

			&::after {
				content: "";
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				background: rgb(255,255,255);
				background: linear-gradient(176deg, rgba(255,255,255,1) 45%, rgba(170,170,170,1) 55%);
				opacity: 0.15;
				transition: all 1s;
				pointer-events: none;
				z-index: 3;
			}

			&__header {
				background-color: rgba($color-green--ok, 0.8);
				color: $color-white;
				padding: 60px;
				position: relative;
			}

			&__body {
				background-color: $color-white;
				width: 100%;

				> * {
					padding: 0 45px;
					line-height: 32px;
				}

				&__status {
					position: relative;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-top: 55px;
					transform: translateX(-50%);
					color: $color-green--ok;
					background: $color-green--ok;
					font-size: 42px;
					height: 50px;
					width: 50px;
					border: 6px solid $color-white;
					border-radius: 50%;
					padding: 20px;

					svg {
						color: $color-white;
					}

					h1 {
						position: absolute;
						left: calc(100% + 10px);
					}
				}

				&__missing-features {
					font-size: 15px;
					line-height: 20px;
					margin-top: 20px;

					ul {
						list-style-type: circle;

						li {
							margin-left: 15px;
						}
					}
				}

				h1 {
					font-size: 22px;
					text-transform: uppercase;
				}

				.controls {
					margin-top: 30px;
					.btn {
						font-size: 20px;
					}
				}
			}
		}
	}

	// Taller
	@media (max-aspect-ratio: 1/1 ) {
		.home {
			.container {
				max-width: 360px;
				min-height: 640px;
			}
		}
	}
</style>
